"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_ACTIVE = exports.DATA_MAGAZINES_FILTER_GROUP = exports.DATA_MAGAZINES_FILTER_ALL = exports.DATA_MAGAZINES_CONTENT = exports.DATA_MAGAZINES_BUTTON = exports.DATA_MAGAZINES = void 0;
exports.DATA_MAGAZINES = 'data-magazines';
exports.DATA_MAGAZINES_BUTTON = 'data-magazines-button';
exports.DATA_MAGAZINES_CONTENT = 'data-magazines-content';
exports.DATA_MAGAZINES_FILTER_ALL = 'data-magazines-filter-all';
exports.DATA_MAGAZINES_FILTER_GROUP = 'data-magazines-filter-group';
exports.CLASS_ACTIVE = 'active';
